/* eslint-disable react/no-array-index-key */
/* eslint-disable consistent-return */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import TestimonialCard from './testimonial-card';

export default function TestimonialSection({
  testimonials, heading, pageName,
}) {
  const containerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fullyVisibleIndexes, setFullyVisibleIndexes] = useState([]);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleScroll = () => {
      const isMobile = window.innerWidth <= 768; // mobile breakpoint
      if (isMobile) {
        // On mobile, show normal left-aligned scroll
        setActiveIndex(0);
        setFullyVisibleIndexes([]);
        return;
      }
      const { scrollLeft, clientWidth } = container;
      const viewportCenter = scrollLeft + clientWidth / 2;
      const children = Array.from(container.children);
      if (!children.length) return;

      let closestIndex = 0;
      let minDistance = Infinity;
      const visibleIndexes = [];

      children.forEach((child, idx) => {
        const left = child.offsetLeft;
        const width = child.clientWidth;
        const right = left + width;

        if (left >= scrollLeft && right <= scrollLeft + clientWidth) {
          visibleIndexes.push(idx);
        }

        const childCenter = left + width / 2;
        const distance = Math.abs(childCenter - viewportCenter);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = idx;
        }
      });

      setActiveIndex(closestIndex);
      setFullyVisibleIndexes(visibleIndexes);
    };

    handleScroll();
    container.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);
    return () => {
      container.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [testimonials]);
  const scrollLeft = () => {
    const container = containerRef.current;
    if (container) {
      container.scrollBy({
        left: -container.clientWidth * 0.8,
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    const container = containerRef.current;
    if (container) {
      container.scrollBy({
        left: container.clientWidth * 0.8,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    if (!testimonials || testimonials.length < 2) return;
    const child = container.children[1];
    if (!child) return;
    const left = child.offsetLeft;
    const width = child.clientWidth;
    const target = left - (container.clientWidth - width) / 2;
    container.scrollTo({ left: target, behavior: 'auto' });
    setActiveIndex(1);
  }, [testimonials]);

  return (
    <section className="relative w-full">
      <div className="flex flex-col gap-[4px] sm:gap-[5px] md:gap-[6px] items-center lg:mb-[18px] mb-4">
        <div className={`${pageName !== 'courseDetail' ? 'items-center' : 'items-start w-full'} flex gap-[10px] sm:gap-[11px] md:gap-[12px] `}>
          {pageName !== 'courseDetail' && <div className="w-[4px] sm:w-[5px] md:w-[6px] h-[24px] sm:h-[28px] md:h-[32px] bg-[#ff5761]" /> }
          <h2 className="lg:text-lg text-base font-semibold text-black">
            {heading}
          </h2>
        </div>
        {/* <h3 className="text-[24px] sm:text-[27px] md:text-[30px] font-semibold text-center text-[#000] leading-[36px] sm:leading-[40px] md:leading-[45px]">
          {subheading}
        </h3> */}
      </div>

      <button
        onClick={scrollLeft}
        type="button"
        className="absolute lg-block hidden left-2 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow hover:scale-105 transition"
        aria-label="Scroll Left"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1439_1993)">
            <path d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z" fill="#646464" />
            <path d="M5.56038 12L11.7809 18.219C11.9217 18.3598 12.0008 18.5508 12.0008 18.75C12.0008 18.9491 11.9217 19.1401 11.7809 19.281C11.64 19.4218 11.449 19.5009 11.2499 19.5009C11.0507 19.5009 10.8597 19.4218 10.7189 19.281L3.96888 12.531C3.89903 12.4613 3.84362 12.3785 3.80581 12.2874C3.768 12.1963 3.74854 12.0986 3.74854 12C3.74854 11.9013 3.768 11.8036 3.80581 11.7125C3.84362 11.6214 3.89903 11.5386 3.96888 11.469L10.7189 4.71897C10.8597 4.57814 11.0507 4.49902 11.2499 4.49902C11.449 4.49902 11.64 4.57814 11.7809 4.71897C11.9217 4.8598 12.0008 5.05081 12.0008 5.24997C12.0008 5.44913 11.9217 5.64014 11.7809 5.78097L5.56038 12Z" fill="#646464" />
          </g>
          <defs>
            <clipPath id="clip0_1439_1993">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>

      <button
        onClick={scrollRight}
        type="button"
        className="absolute lg-block hidden right-2 top-1/2 -translate-y-1/2 z-10 bg-white p-2 rounded-full shadow hover:scale-105 transition"
        aria-label="Scroll Right"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1439_1993)" transform="rotate(180 12 12)">
            <path d="M5.25 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H5.25C5.05109 12.75 4.86032 12.671 4.71967 12.5303C4.57902 12.3897 4.5 12.1989 4.5 12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25Z" fill="#646464" />
            <path d="M5.56038 12L11.7809 18.219C11.9217 18.3598 12.0008 18.5508 12.0008 18.75C12.0008 18.9491 11.9217 19.1401 11.7809 19.281C11.64 19.4218 11.449 19.5009 11.2499 19.5009C11.0507 19.5009 10.8597 19.4218 10.7189 19.281L3.96888 12.531C3.89903 12.4613 3.84362 12.3785 3.80581 12.2874C3.768 12.1963 3.74854 12.0986 3.74854 12C3.74854 11.9013 3.768 11.8036 3.80581 11.7125C3.84362 11.6214 3.89903 11.5386 3.96888 11.469L10.7189 4.71897C10.8597 4.57814 11.0507 4.49902 11.2499 4.49902C11.449 4.49902 11.64 4.57814 11.7809 4.71897C11.9217 4.8598 12.0008 5.05081 12.0008 5.24997C12.0008 5.44913 11.9217 5.64014 11.7809 5.78097L5.56038 12Z" fill="#646464" />
          </g>
          <defs>
            <clipPath id="clip0_1439_1993">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </button>
      <div
        ref={containerRef}
        className="flex gap-[10px] lg:gap-7 overflow-x-auto scroll-smooth snap-x snap-mandatory scrollbar-hide lg:pt-0 pt-8"
      >
        {testimonials?.map((testimonial, index) => {
          const isFullyVisible = fullyVisibleIndexes.includes(index);
          const isActive = index === activeIndex;
          const keepBright = fullyVisibleIndexes.length >= 2 ? isFullyVisible : isActive;
          // let keepBright = true;
          // if (window.innerWidth > 768) {
          //   const isFullyVisible = fullyVisibleIndexes.includes(index);
          //   const isActive = index === activeIndex;
          //   keepBright = fullyVisibleIndexes.length >= 2 ? isFullyVisible : isActive;
          //   keepBright = fullyVisibleIndexes.length >= 2 ? isFullyVisible : isActive;
          // }

          return (
            <div
              key={index}
              className={`snap-center w-[312px] lg:w-[49%] flex-flexAuto  ${pageName !== 'courseDetail' ? 'md:my-7' : ''} relative `}
            >
              <TestimonialCard
                testimonial={testimonial}
                isActive={keepBright}
                isSide={!keepBright}
                pageName={pageName}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}

TestimonialSection.propTypes = {
  testimonials: PropTypes.array,
  heading: PropTypes.string,
  pageName: PropTypes.string,
  // subheading: PropTypes.string,
};
